import { images } from "../assets/img";

export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/GFQuWL1sMCmQF9e",
  address: "Unit 15, Quinton Court Shopping Centre, Wardles Ln, Great Wyrley, United Kingdom",
  ggMapIframeUrl:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3664.8342213400256!2d-2.0182466!3d52.657915599999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48709f70086d5837%3A0x30d6b6a5d2145257!2sHappy%20Nails%20Great%20Wyrley!5e1!3m2!1sen!2s!4v1740736226199!5m2!1sen!2s",
  email: "happynails28012025@gmail.com",
  tel: "+447934616868",
  phone: "+44 793 461 6868",
  facebookId:"592523080601315",
  instagramName: "happy_nails_greatwyrley",
  name: "Happy Nails Great Wyrley",
  bookingUrl: "https://happynailsgreatwyrley.setmore.com",
  openingTime:{
    openTime:{weekdays: "MONDAY - SATURDAY", time:"09:30 - 18:30"},
    closeTime:{weekdays: "SUNDAY & BANK HOLIDAY", time:"CLOSED"}
  }
};

NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/profile.php?id=${NAIL_SHOP_INFO.facebookId}`
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`

export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://solcomarketing.com",

  huaCatLuongWebsite: "https://huacatluong.com",
};

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    name: "Heather Braswell",
    feedback:
      "Ã¢â‚¬Å“Beautiful salon, tons of colors and the nicest peopleÃ¢â‚¬Â¦..and most importantly excellent work!   The shop is new but the people are very experienced and it shows.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/g7mJPq8.png",
  },
  {
    name: "Jana Rudoll",
    feedback:
      "Ã¢â‚¬Å“Went to Happy Nails Great Wyrley salon today. Very friendly.  My nails were done to an excellent standard. I will definitely go back .  Great prices too. So worth it. One happy customer.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/VxekuRS.png",
  },
  {
    name: "Louise Medve",
    feedback:
      "Ã¢â‚¬Å“Thank you Hanna!!! Amazing, friendly and professional serviceÃ¢â‚¬Â¦.. absolutely love my acrylic French tips on hands and toes. Beautiful clean and fresh salon with a toilet which is brilliant!! Daughter had gel french tips and loves them. The best Nail Salon in Edinburgh by far Ã¢â‚¬Â¦.highly recommend a visit - the massage pedicure chairs are just wonderful Ã¢ÂÂ¤Ã¯Â¸ÂÃ¢ÂÂ¤Ã¯Â¸ÂÃ¢â‚¬Â",
    avatar: "https://i.imgur.com/0JaNnhK.png",
  },
  {
    name: "Lucia Poulter",
    feedback:
      "Ã¢â‚¬Å“Great  salon, IÃ¢â‚¬â„¢ve had a pedicure and manicure with different people and am very happy with both. Lovely people and well priced. IÃ¢â‚¬â„¢ll definitely be back Ã°Å¸â€˜Å’Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/aCEUi1W.png",
  },
  {
    name: "Sarah Hickson",
    feedback:
      "Ã¢â‚¬Å“Walked in and was seen to immediately, the staff were so lovely! Had nice conversation while I got BIAB done, and can 100% say this is the best IÃ¢â‚¬â„¢ve ever had my nails done in edinburgh. A lovely space, lovely people, and great results. This will definitely be my new nail spot! :)Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/F7M14q2.png",
  },
  {
    name: "Isabella White",
    feedback:
      "Ã¢â‚¬Å“I booked a last-minute appointment at Happy Nails Great Wyrley, and they exceeded my expectations. My gel manicure has been flawless for weeks!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/KxhUFKM.jpg",
  },
  {
    name: "Scarlett Brown",
    feedback:
      "Ã¢â‚¬Å“The calm environment at Happy Nails Great Wyrley makes it my go-to spot. Their tips for maintaining healthy nails have been really helpful.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/kI3rsKc.jpg",
  },
  {
    name: "Ella Wilson",
    feedback:
      "Ã¢â‚¬Å“I treated my mom to a day at Happy Nails Great Wyrley for her birthday, and it was perfect. The staff made us feel so special with their attention to detail.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/92gXkP8.jpg",
  },
];

export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "About Us", navigationKey: "about-us" },
  { name: "Services", navigationKey: "services" },
  { name: "Booking", navigationKey: NAIL_SHOP_INFO.bookingUrl },
  // { name: "Contacts", navigationKey: "contactsRef" },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];
